import * as React from 'react';
import type { DynamicComponentProps } from '@/types/commontypes';
import styles from '@/styles/global.module.css';
import { OpacitySlider } from './OpacitySlider';

const LineOpacityComponent: React.FC<DynamicComponentProps<number>> = ({ label, value, onChange, disabled }) => {
  const handleSliderChange = (value: number) => {
    onChange(value);
  };

  return (
    <div>
      <div style={{ marginBottom: '10px' }}>
        <label>{label}</label>
      </div>

      <OpacitySlider
        color="rgb(41, 98, 255)"
        min={0}
        max={1}
        step={0.01}
        value={value}
        className={`${styles.checker}`}
        onChange={handleSliderChange}
        disabled={disabled}
        style={{
          width: '110px',
          height: '10px',
        }}
      />
    </div>
  );
};

export default LineOpacityComponent;
